(function($) {
    'use strict';

    var validationOption = {
        onfocusout: function(element) {
            $(element).valid();
        },
        focusCleanup: true,
        errorElement: "em",
        errorPlacement: function(error, element) {
            // Add the `help-block` class to the error element
            error.addClass("help-block");
            // Add `has-feedback` class to the parent div.form-group
            // in order to add icons to inputs
            element.parents(".fcc").addClass("has-feedback");
            if (element.prop("type") === "checkbox") {
                error.insertAfter(element.parent("label"));
            } else {
                error.insertAfter(element);
            }
            // Add the span element, if doesn't exists, and apply the icon classes to it.
            if (!element.next("span")[0]) {
                //$("<span class='glyphicon glyphicon-remove form-control-feedback'></span>").insertAfter(element);
            }
        },
        success: function(label, element) {
            // Add the span element, if doesn't exists, and apply the icon classes to it.
            if (!$(element).next("span")[0]) {
                //$("<span class='glyphicon glyphicon-ok form-control-feedback'></span>").insertAfter($(element));
            }
        },
        highlight: function(element, errorClass, validClass) {
            $(element).parents(".fcc").addClass("has-error").removeClass("has-success");
            $(element.form).find("label[for=" + element.id + "]").addClass("text-danger").removeClass("text-success");
            //$(element).next("span").addClass("glyphicon-remove").removeClass("glyphicon-ok");
        },
        unhighlight: function(element, errorClass, validClass) {
            if ($(element).val() !== "") {
                $(element).parents(".fcc").addClass("has-success").removeClass("has-error");
                $(element.form).find("label[for=" + element.id + "]").addClass("text-success").removeClass("text-danger");
                //$(element).next("span").addClass("glyphicon-ok").removeClass("glyphicon-remove");
            } else {
                $(element).parents(".fcc").removeClass("has-success").removeClass("has-error");
                $(element.form).find("label[for=" + element.id + "]").removeClass("text-success").removeClass("text-danger");
                //$(element).next("span").removeClass("glyphicon-ok").removeClass("glyphicon-remove");
            }
        }
    };

    if (typeof localStorage !== "object" ||
        typeof localStorage.setItem !== "function" ||
        typeof localStorage.getItem !== "function" ||
        typeof localStorage.removeItem !== "function") {

        localStorage = function() {
            return {
                setItem: function(key, value) {
                    document.cookie = key + "=" + value;
                },
                getItem: function(key) {
                    var m = document.cookie.split(";");
                    for (var i = 0; i < m.length; m++) {
                        var g = m[i].split("=");
                        if (g[0] === key) {
                            return g[1];
                        }
                    }
                    return undefined;
                },
                removeItem: function(key) {
                    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                }
            };
        };
    }

    // Bare Function to handle Get Requests
    function AJAX(url, headers, cors, html) {
        cors = cors ? 'jsonp' : 'json';
        html = html ? true : false;
        if (html) {
            cors = 'text/html';
        }
        if (typeof headers === "undefined") {
            headers = function(xhr) {};
        }
        console.log(cors);
        return {
            Get: function() {
                return new Promise(function(_callback, _err_callback) {
                    console.log("AJAX.Get Called");
                    $.ajax({
                        url: url,
                        type: 'GET',
                        beforeSend: headers,
                        dataType: cors,
                        success: function(data) {
                            console.log(data);
                            _callback(data);
                        },
                        error: function(xhr, status, err) {
                            console.error(err);
                            _err_callback(xhr.responseJSON);
                        }
                    });
                });
            },
            Post: function(dataObj, raw_upload, _progress_cb) {
                dataObj = dataObj ? dataObj : {};
                _progress_cb = _progress_cb ? _progress_cb : function(e) { console.log(e); };
                raw_upload = raw_upload ? true : false;
                return new Promise(function(_callback, _err_callback) {
                    console.log("AJAX.Post Called");
                    var _post_options = {
                        url: url,
                        type: 'POST',
                        beforeSend: headers,
                        success: function(data) {
                            console.log(data);
                            _callback(data);
                        },
                        error: function(xhr, status, err) {
                            console.error(err);
                            _err_callback(xhr.responseJSON);
                        }
                    };
                    if (!raw_upload) {
                        _post_options.dataType = cors;
                        _post_options.contentType = 'application/json';
                        _post_options.data = JSON.stringify(dataObj);
                    } else {
                        _post_options.processData = false;
                        _post_options.contentType = false;
                        _post_options.data = dataObj;
                        _post_options.xhr = function() {
                            var mXhr = $.ajaxSettings.xhr();
                            if (mXhr.upload) {
                                mXhr.upload.addEventListener('progress', _progress_cb, false);
                            }
                            return mXhr;
                        };
                    }
                    $.ajax(_post_options);
                });
            }
        };
    }

    function boolReturn(_callback) {
        return function(res, status, err) {
            if (err !== undefined) {
                // We've AJAX Error
                _callback(false);
                return;
            }
            // We've No AJAX Error
            if (res.status === "success" || res.status === 200) {
                _callback(true);
            } else {
                _callback(false);
            }
        };
    }

    function genReturn(_callback) {
        return function(res, status, err) {
            if (err !== undefined) {
                // We've AJAX Error
                _callback(res, status, err);
                return;
            }
            // We've No AJAX Error
            _callback(res);
        };
    }

    function getCookie(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    function fetchAuthHeader(noAuth) {
        noAuth = noAuth ? true : false;
        var tokenKey = localStorage.getItem("tokenKey");
        var csrfToken = getCookie('csrftoken');
        return function(xhr) {
            if (!noAuth) {
                xhr.setRequestHeader('Authorization', "Bearer " + tokenKey);
                // Add CSRF Token as well
                xhr.setRequestHeader('X-CSRFToken', csrfToken);
            }
        };
    }

    function setToken(token) {
        return new Promise(function(_callback) {
            // Let's Save the received token to Local Store
            localStorage.setItem("tokenKey", token);
            _callback(true);
        });
    }

    function resetToken() {
        return new Promise(function(_callback) {
            // Let's Save the received token to Session Store
            localStorage.removeItem("tokenKey");
            _callback(true);
        });
    }

    function setLocalKey(key, value) {
        return new Promise(function(_callback) {
            localStorage.setItem(key, value);
            _callback(true);
        });
    }

    function getLocalKey(key) {
        return new Promise(function(_callback) {
            _callback(localStorage.getItem(key));
        });
    }

    function resetLocalKey(key) {
        return new Promise(function(_callback) {
            localStorage.removeItem(key);
            _callback(true);
        });
    }

    window.ajaxlib = Object.freeze({
        AJAX: AJAX,
        boolReturn: boolReturn,
        genReturn: genReturn,
        fetchAuthHeader: fetchAuthHeader,
        setToken: setToken,
        resetToken: resetToken,
        validationOption: validationOption,
        getCookie: getCookie,
        setLocalKey: setLocalKey,
        getLocalKey: getLocalKey,
        resetLocalKey: resetLocalKey
    });

})(jQuery);